import React from 'react'

import {
  TextField,
  Tooltip
} from '@mui/material';
import { normalizePhone } from '../../../../util/functions'

const CrmTextField = (props) => {
  const { name, label, value, inputProps, onChange, disabled, helperText, errorMsg, autoComplete = 'on', required, tooltip, placeholder, maxNumber } = props
  
  // Handle validation for number fields with maxNumber
  const handleChange = (event) => {
    if (type === 'number' && maxNumber && event.target.value !== '') {
      const inputValue = parseFloat(event.target.value);
      const maxValue = parseFloat(maxNumber);
      
      if (!isNaN(inputValue) && !isNaN(maxValue) && inputValue > maxValue) {
        // Don't allow the change if it exceeds maxNumber
        return;
      }
    }
    
    // Call the original onChange handler
    onChange(event);
  };
  let { type } = props
  let maxRows, minRows, multiline//rows,

  if (type === 'textarea') {
    type = 'text'
    // rows = 4
    minRows = 4
    maxRows = 34
    multiline = true
  }

  let toDisplayValue = value

  if (type === 'phone') toDisplayValue = normalizePhone(value)

  const textField = <TextField
    label={label}
    name={name}
    value={toDisplayValue}
    type={type} // text, number, email, password, tel, url, search, date, datetime-local, time, month, week, color, file, hidden
    inputProps={{
      ...(type === 'number' && maxNumber ? { max: maxNumber } : {}),
      ...inputProps
    }}
    onChange={handleChange}
    fullWidth
    disabled={disabled}
    size="small"
    error={Boolean(errorMsg)}
    helperText={errorMsg || helperText}
    autoComplete={autoComplete}
    // rows={rows}
    maxRows={maxRows}
    minRows={minRows}
    multiline={multiline}
    required={required}
    placeholder={placeholder}
  />
  return tooltip ? (
    <Tooltip title={tooltip} arrow placement="top"
      componentsProps={{
        tooltip: {
          sx: {
            maxWidth: 300, // or any width you need
            whiteSpace: 'pre-line' // optional: for multiline text
          },
        },
      }}>
      {textField}
    </Tooltip>
  ) : (
    textField
  );


}

export default CrmTextField